import { AnnouncementCode, IGetResAnnouncementList } from '../../frontend-libs/evlapp-types';

import { RestApi } from '../../common/services';
import { store } from '../../common/store/store';

export const getAnnouncements = async (): Promise<IGetResAnnouncementList> => {
  const buildingId = store.getState().security.ui.buildingId;

  return await RestApi.get<never, IGetResAnnouncementList>(`/building/${buildingId}/announcement`);
};

export const dismissAnnouncement = async (code: AnnouncementCode): Promise<IGetResAnnouncementList> => {
  const buildingId = store.getState().security.ui.buildingId;

  return await RestApi.post<never, IGetResAnnouncementList>(`/building/${buildingId}/announcement/${code}/dismiss`);
};
